import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'bilancio-partecipata';
export const ENTITY_PLURAL = 'Bilancio Partecipata';
export const gridColumns: EntityListField[] = [
  // {
  //   elementLabel: 'Esercizio',
  //   filterType: FilterType.number,
  //   fieldType: FieldType.integer,
  //   field: 'esercizio',
  //   sort: 'desc',
  // },
  {
    elementLabel: 'Descrizione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizione',
    minWidth: 160,
  },
  {
    elementLabel: 'Approvato',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'approvato',
    minWidth: 100,
    maxWidth: 100,
  },
  {
    elementLabel: 'Estremi Delibera',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'estremiDelibera',
  },
  {
    elementLabel: 'Provvisorio',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'provvisorio',
    minWidth: 120,
    maxWidth: 120,
  },
  {
    elementLabel: 'Utilizzato per consolidamento/analisi',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'utilizza',
  },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
